import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@shigo-ui/ui';

import { dashboardApiErrorMessage } from './apiErrorMessages';
import { markRequestErrorNotified, showRequestError } from './requestErrorToast';

export const unauthorizedSessionEvent = 'shigo:unauthorized-session';

const unauthorizedDispatchPending = new Set<string | undefined>();

export function createShigoQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        handleShigoRequestError(error);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        handleShigoRequestError(error);
      },
    }),
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => !isUnauthorizedRequest(error) && failureCount < 3,
      },
    },
  });
}

export function handleShigoRequestError(error: unknown, accessToken?: string) {
  if (typeof window === 'undefined') {
    return;
  }

  if (isUnauthorizedRequest(error)) {
    if (markRequestErrorNotified(error)) return;
    if (!unauthorizedDispatchPending.has(accessToken)) {
      unauthorizedDispatchPending.add(accessToken);
      toast.error(dashboardApiErrorMessage(error));
      window.dispatchEvent(new CustomEvent(unauthorizedSessionEvent, { detail: accessToken }));
      window.setTimeout(() => {
        unauthorizedDispatchPending.delete(accessToken);
      }, 0);
    }
    return;
  }

  showRequestError(error);
}

function isUnauthorizedRequest(error: unknown) {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    (error as { status?: unknown }).status === 401
  );
}
